import React, { useState, useEffect, useContext } from "react";
import { Typography, Stack, Alert, Tooltip } from "@mui/material";
import {
  Circle,
  AddCircleOutline,
  RemoveCircleOutline,
} from "@mui/icons-material";

import { useParams } from "react-router-dom";
import { AuthContext } from "../../Auth/Context";
import useWexClient from "../../hooks/Clients/wexClient,";

import ButtonComponent from "../atoms/ButtonComponent";
import CircularProgressBar from "../atoms/Downloader";
import { TablePagination } from "@mui/material";
import stylesLoader from "./../../styles/Molecules/Loader/Loader";
import stylesAgent from "../../styles/Molecules/Agents/styleAgents";
import CardComponent from "../atoms/CardComponent";
import InputLabel from "../atoms/InputLabel";
import MuiModal from "../atoms/MuiModal";
import TooltipPassword from "../organisms/TooltipPassword";
import AlertComponent from "../atoms/Alert";
import stylesTable from "../../styles/Molecules/Table/table";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import TableLine from "../atoms/TableLine";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";
import FileComponent from "../atoms/ButtonFile";
import ModalAgents from "../../views/OptionDashboard/Modals/ModalAgents";
import { usePermissions } from "../../hooks/usePermissions";

function Agentes() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { payload } = useContext(AuthContext);
  const { can } = usePermissions(payload);

  const {
    getRegions, // opciones de regiones para asignar a agentes
    updateUser, // actualizar datos de usuario (nombre, email, perfil, región) y borrar usuario (enviar status 10)
    getServices, //
    getAllAgents, // obtener lista de agentes registrados para Admins
    usersForRegion, // obtener lista de agentes registrados para Supervisores (filtrado por región)
    createUser,
    updatePasswordFetch,
  } = useWexClient();

  const [open, setOpen] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([""]);
  const [regionOptions, setRegionOptions] = useState([]);

  const optionsProfile = [
    { label: t("Welcome.text115"), value: "_SUPERVISOR_" },
    { label: t("Welcome.text300"), value: "_AGENT_" },
  ];
  const optionsProfileForSupervisor = [
    { label: t("Welcome.text300"), value: "_AGENT_" },
  ];

  const optionsStatus = [
    { label: t("Welcome.text37"), value: 1 },
    { label: t("Welcome.text117"), value: 0 },
    { label: t("Welcome.text118"), value: 10 },
  ];

  const [isSupervisor, setIsSupervisor] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  // Permisos de usuario
  const canCreateAgent = can("create", "user", "agent");
  const canUpdateUser = can("update", "user");
  const canEditName = can("update", "user", "name");
  const canEditUsername = can("update", "user", "username");
  const canDeleteUser = can("delete", "user");
  // Puede editar si tiene permisos para editar al menos un campo
  const canEditUser = canUpdateUser && (canEditName || canEditUsername);

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [alias, setAlias] = useState("");
  const [code, setCode] = useState("");
  const [status, setStatus] = useState(1);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [userType, setUserType] = useState("_AGENT_");
  const [showAlert, setShowAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState("");
  const [typeAlertError, setTypeAlertError] = useState("error");
  const [modalVisibleAdd, setModalVisibleAdd] = useState(false);
  const [typeAlert, setTypeAlert] = useState("success");

  const [data, setData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const searchColumns = ["Usuario", "Nombre"];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPhone, setEditPhone] = useState("");
  const [editAlias, setEditAlias] = useState("");
  const [editCode, setEditCode] = useState("");
  const [editProfile, setEditProfile] = useState("");
  const [editRegions, setEditRegions] = useState([""]);
  const [editPassword, setEditPassword] = useState("");
  const [editPasswordConfirm, setEditPasswordConfirm] = useState("");
  const [editErrorMessagePass, setEditErrorMessagePass] = useState("");
  const [editPresentPassConfirm, setEditPresentPassConfirm] = useState(false);

  const [typeService, setTypeService] = useState([]);
  const [serviceAdd, setServiceAdd] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [saveItem, setSaveItem] = useState(null);
  const [saveName, setSaveName] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);

  const [presentName, setPresentName] = useState(false);
  const [presentMail, setPresentMail] = useState(false);
  const [presentPass, setPresentPass] = useState(false);
  const [presentPassConfirm, setPresentPassConfirm] = useState(false);
  const [errorMessagePass, setErrorMessagePass] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [fileName, setFileName] = useState("");
  const [listName, setListName] = useState("");
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [file, setFile] = useState(null);

  const handleTextChangeName = (text) => {
    setName(text);
    setPresentName(text.trim() !== "");
  };

  const handleTextChangeUser = (text) => {
    setEmail(text);
    setPresentMail(text.trim() !== "");
  };

  const handleTextChangePass = (text) => {
    if (!text.trim()) {
      setPresentPass(false);
      setErrorMessage(t("Welcome.text131"));
      return;
    }

    setPassword(text);
    let errorMessages = [];
    const trim = text.trim();

    if (trim.length < 8) errorMessages.push(t("Welcome.text132"));
    if (trim.length > 15) errorMessages.push(t("Welcome.text133"));
    if (!/[A-Z]/.test(trim)) errorMessages.push(t("Welcome.text134"));
    if (!/[a-z]/.test(trim)) errorMessages.push(t("Welcome.text135"));
    if (!/\d/.test(trim)) errorMessages.push(t("Welcome.text136"));
    if (/\s/.test(trim)) errorMessages.push(t("Welcome.text137"));
    // if (!/[!@#$%^&*()]/.test(trim)) errorMessages.push(t("Welcome.text138"));

    const errorMessage = t("Welcome.text139") + errorMessages.join(", ");
    setPresentPass(errorMessages.length === 0);
    setErrorMessage(errorMessage);
  };

  const handleConfirmPass = (text) => {
    setPasswordConfirm(text);
    if (password !== text) {
      setPresentPassConfirm(true);
      setErrorMessagePass(t("Welcome.text244"));
    } else {
      setPresentPassConfirm(false);
      setErrorMessagePass("");
    }
  };

  const validatePassword = (text) => {
    const trim = text.trim();

    if (trim.length < 8) return false;
    if (trim.length > 15) return false;
    if (!/[A-Z]/.test(trim)) return false;
    if (!/[a-z]/.test(trim)) return false;

    return true;
  };

  const handleEditTextChangePass = (text) => {
    if (!text.trim()) {
      setEditErrorMessagePass(t("Welcome.text131"));
      return;
    }

    setEditPassword(text);
    let errorMessages = [];
    const trim = text.trim();

    if (trim.length < 8) errorMessages.push(t("Welcome.text132"));
    if (trim.length > 15) errorMessages.push(t("Welcome.text133"));
    if (!/[A-Z]/.test(trim)) errorMessages.push(t("Welcome.text134"));
    if (!/[a-z]/.test(trim)) errorMessages.push(t("Welcome.text135"));
    if (!/\d/.test(trim)) errorMessages.push(t("Welcome.text136"));
    if (/\s/.test(trim)) errorMessages.push(t("Welcome.text137"));

    const errorMessage = t("Welcome.text139") + errorMessages.join(", ");
    setEditErrorMessagePass(errorMessage);
  };

  const handleEditConfirmPass = (text) => {
    setEditPasswordConfirm(text);
    if (editPassword !== text) {
      setEditPresentPassConfirm(true);
      setEditErrorMessagePass(t("Welcome.text244"));
    } else {
      setEditPresentPassConfirm(false);
      setEditErrorMessagePass("");
    }
  };

  const handleClickCancel = () => {
    setUserType("_AGENT_");
    setPassword("");
    setPasswordConfirm("");
    setName("");
    setEmail("");
    setPhone("");
    setAlias("");
    setCode("");
    setSelectedRegions([""]);
    // Limpiar alertas
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    setModalVisibleAdd(false);
  };

  const handleAddRegion = () => {
    setSelectedRegions([...selectedRegions, ""]);
  };

  const handleRegionChange = (index, value) => {
    const updated = [...selectedRegions];
    updated[index] = value;
    setSelectedRegions(updated);
  };

  const handleRemoveRegion = (index) => {
    const updated = selectedRegions.filter((_, i) => i !== index);
    setSelectedRegions(updated);
  };

  const handleAddEditRegion = () => {
    setEditRegions([...editRegions, ""]);
  };

  const handleEditRegionChange = (index, value) => {
    const updated = [...editRegions];
    updated[index] = value;
    setEditRegions(updated);
  };

  const handleRemoveEditRegion = (index) => {
    const updated = editRegions.filter((_, i) => i !== index);
    setEditRegions(updated);
  };

  const buildCreateUserPayload = () => {
    return {
      regionIds: selectedRegions,
      nameUser: name.trim(),
      user: email.trim(), // si realmente user es login
      email: email.trim(), // si backend lo requiere
      phone: phone.trim(),
      password,
      serviceId: id,
      userClass: userType === "_SUPERVISOR_" ? "_SUPERVISOR_" : "_AGENT_",
      profile: {
        alias: alias.trim(),
        code: code.trim(),
        class: userType === "_SUPERVISOR_" ? "_SUPERVISOR_" : "_AGENT_",
        name: name.trim(),
        typeAgent: "_ADJUSTER_",
        tz: "America/Mexico_City",
      },
    };
  };

  const handleModalAdd = async () => {
    if (!canCreateAgent) {
      setMessageAlertError("No tienes permisos para crear usuarios");
      setShowAlertError(true);
      return;
    }
    try {
      if (isSupervisor && userType === "_SUPERVISOR_") {
        setMessageAlertError("Un supervisor no puede crear otro supervisor.");
        setShowAlertError(true);
        return;
      }
      if (!name || !email || !password) {
        setMessageAlertError("Todos los campos son obligatorios.");
        setShowAlertError(true);
        return;
      }

      if (!validatePassword(password)) {
        setMessageAlertError("La contraseña no cumple los requisitos.");
        setShowAlertError(true);
        return;
      }

      if (presentPassConfirm) {
        setMessageAlertError("Las contraseñas no coinciden.");
        setShowAlertError(true);
        return;
      }
      if (password !== passwordConfirm) {
        setMessageAlertError("Las contraseñas no coinciden.");
        setShowAlertError(true);
        return;
      }

      const payload = buildCreateUserPayload();
      const response = await createUser(payload);

      if (response?.success === false) {
        setMessageAlertError(response?.message || "Error al crear usuario");
        setShowAlertError(true);
        return;
      }

      setMessageAlert(response?.message || "Usuario creado correctamente");
      setTypeAlert("success");
      setShowAlert(true);

      setTimeout(() => {
        getAgentsData();
        handleClickCancel();
      }, 1500);
    } catch (error) {
      setMessageAlertError(error?.message || "Error inesperado");
      setShowAlertError(true);
    }
  };

  const handleCloseModalAdd = () => {
    setModalVisibleAdd(false);
    handleClickCancel();
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleClickAdd = () => {
    // Limpiar alertas al abrir modal
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    // Limpiar campos
    setName("");
    setEmail("");
    setPhone("");
    setAlias("");
    setCode("");
    setPassword("");
    setPasswordConfirm("");
    setUserType("_AGENT_");
    setModalVisibleAdd(true);

    if (regionOptions.length > 0) {
      setSelectedRegions([""]);
    } else {
      setSelectedRegions([""]);
    }
  };

  const handleCloseModal = () => {
    // Limpiar alertas al cerrar modal de edición
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    setIsModalVisible(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getAgentsData = async () => {
    setIsLoading(true);

    try {
      const role = payload?.profile?.class;
      const regionIds = payload?.regionIds;
      const body = { regionIds };
      const idService = payload?.service;

      if (role === "_SUPERVISOR_" && !regionIds) {
        console.warn("Supervisor without regionId — request cancelled");
        setData([]);
        return;
      }

      const response =
        role === "_SUPERVISOR_"
          ? await usersForRegion(body)
          : await getAllAgents(idService);

      const agents = Array.isArray(response?.agents)
        ? response.agents
        : Array.isArray(response)
          ? response
          : [];

      const roleUser = payload?.profile?.class;

      const filteredAgents = agents.filter((agent) => {
        if (agent?.status === 10) return false;

        if (roleUser === "_ADMIN_") {
          return agent?.profile?.class !== "_ADMIN_";
        }

        if (roleUser === "_SUPERVISOR_") {
          return agent?.profile?.class === "_AGENT_";
        }

        return false;
      });

      setData(filteredAgents);
    } catch (error) {
      console.error("Error fetching agent data:", error?.message || error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = (item, event) => {
    event.preventDefault();
    event.stopPropagation();
    // Limpiar alertas al abrir modal de edición
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    setSaveItem(item);
    setEditName(item.profile?.name || "");
    setEditEmail(item.user || "");
    setEditPhone(item.phone || "");
    setEditAlias(item.profile?.alias || "");
    setEditCode(item.profile?.code || "");
    setEditProfile(item.profile?.class || "");
    // Limpiar campos de password
    setEditPassword("");
    setEditPasswordConfirm("");
    setEditErrorMessagePass("");
    setEditPresentPassConfirm(false);

    // Normalizar regiones
    const regions = Array.isArray(item.regionIds)
      ? item.regionIds.map((r) => r._id || r)
      : [item.regionIds?._id || item.regionIds || ""];

    const cleanRegions = regions.filter(Boolean);

    setEditRegions(cleanRegions.length ? cleanRegions : [""]);
    setIsModalVisible(true);
  };

  const [modalVisibleDelete, setModalVisibleDelete] = useState(false);

  const handleDeleteClick = (item) => {
    // Limpiar alertas al abrir modal de eliminación
    setShowAlert(false);
    setShowAlertError(false);
    setMessageAlert("");
    setMessageAlertError("");
    setModalVisibleDelete(true);
    setSaveName(item.profile.name);
    setItemToDelete(item);
  };

  const handleClickTrashClose = () => {
    setModalVisibleDelete(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getRegionsList = async () => {
    try {
      const body = {
        idService: id,
      };

      const response = await getRegions(body);

      const options = (response?.data || [])
        .filter((r) => r.status)
        .map((r) => ({
          label: r.name,
          value: r._id,
        }));

      setRegionOptions(options);

      // default automático si no hay selección
      if (options.length && selectedRegions.every((r) => r === "")) {
        setSelectedRegions([options[0].value]);
      }
    } catch (error) {
      console.error("Error loading regions:", error);
      setRegionOptions([]);
    }
  };

  const getProfileLabel = (profileClass, t) => {
    switch (profileClass) {
      case "_SUPERVISOR_":
        return t("Welcome.text115"); // Supervisor
      case "_AGENT_":
        return t("Welcome.text300"); // Ajustador
      default:
        return profileClass || "-";
    }
  };

  const getServicesList = async () => {
    try {
      const apiData = await getServices(payload._id);

      const serviceData = Array.isArray(apiData)
        ? apiData.map((item) => ({
            label: item.name,
            value: item._id,
          }))
        : [];

      setTypeService(serviceData);
    } catch (error) {
      console.error("Error obteniendo servicios:", error);
      setTypeService([]);
    }
  };

  useEffect(() => {
    const role = payload?.profile?.class;

    setIsAdmin(role === "_ADMIN_");
    setIsSupervisor(role === "_SUPERVISOR_");
  }, [payload]);

  useEffect(() => {
    getAgentsData();
    getServicesList();
    getRegionsList();
  }, [payload]);

  const closeModalFile = () => {
    setOpenFile(false);
    setListName("");
    setFileName("");
  };

  const Buttons = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")}
          onClick={handleCloseModalAdd}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text24")}
          onClick={handleModalAdd}
          backgroundColor="#1976d2"
        />
      </div>
    </>
  );

  if (isLoading) {
    return (
      <div style={stylesLoader.containerLoader}>
        <CircularProgressBar />
      </div>
    );
  }

  const sourceData = Array.isArray(data) ? data : [];
  const filteredData = sourceData.filter((item) =>
    searchColumns.some((column) => {
      if (column === "Usuario") {
        return item.user.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (column === "Nombre") {
        return item.profile.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      }
      return false;
    }),
  );

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedData = filteredData.slice(startIndex, endIndex);
  //Para Supervisores
  const columnTitlesForSupervisor = [
    t("Welcome.text120"),
    t("Welcome.text3"),
    "Alias",
/*     "Teléfono", 
    "Código",*/
    "Permisos", 
    t("Welcome.text16"),
  ];
  function cellRendererForSupervisor(agentItem, title) {
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {title === t("Welcome.text120") ? (
          agentItem.user
        ) : title === t("Welcome.text3") ? (
          agentItem.profile.name
        ) : title === "Teléfono" ? (
          agentItem.phone || "-"
        ) : title === "Alias" ? (
          agentItem.profile?.alias || "-"
        ) : title === "Código" ? (
          agentItem.profile?.code || "-"
        ) : title === "Permisos" ? (
          getProfileLabel(agentItem.profile?.class, t)
        ) : title === t("Welcome.text16") ? (
          <Tooltip
            title={
              agentItem.status === 1
                ? t("Welcome.text37")
                : agentItem.status === 0
                  ? t("Welcome.text117")
                  : t("Welcome.text118")
            }
            arrow
          >
            <Circle
              sx={{
                fontSize: 20,
                color:
                  agentItem.status === 1
                    ? "#8db600"
                    : agentItem.status === 0
                      ? "#f7d547"
                      : "#c20000",
              }}
            />
          </Tooltip>
        ) : null}
      </div>
    );
  }
  // Para Admins
  const columnTitles = [
    t("Welcome.text120"),
    t("Welcome.text3"),
    t("Welcome.text301"),
    "Teléfono",
    "Alias",
    "Código",
    "Permisos",
    t("Welcome.text16"),
  ];
  function cellRenderer(agentItem, title) {
    return (
      <div style={{ fontFamily: "Raleway, sans-serif", fontSize: "14px" }}>
        {title === t("Welcome.text120") ? (
          agentItem.user
        ) : title === t("Welcome.text3") ? (
          agentItem.profile.name
        ) : title === t("Welcome.text301") ? (
          Array.isArray(agentItem.regionIds) ? (
            agentItem.regionIds.map((r) => r.name).join(", ") || "-"
          ) : (
            agentItem.regionIds?.name || "-"
          )
        ) : title === "Teléfono" ? (
          agentItem.phone || "-"
        ) : title === "Alias" ? (
          agentItem.profile?.alias || "-"
        ) : title === "Código" ? (
          agentItem.profile?.code || "-"
        ) : title === "Permisos" ? (
          getProfileLabel(agentItem.profile?.class, t)
        ) : title === t("Welcome.text16") ? (
          <Tooltip
            title={
              agentItem.status === 1
                ? t("Welcome.text37")
                : agentItem.status === 0
                  ? t("Welcome.text117")
                  : t("Welcome.text118")
            }
            arrow
          >
            <Circle
              sx={{
                fontSize: 20,
                color:
                  agentItem.status === 1
                    ? "#8db600"
                    : agentItem.status === 0
                      ? "#f7d547"
                      : "#c20000",
              }}
            />
          </Tooltip>
        ) : null}
      </div>
    );
  }

  const activeColumns = isSupervisor ? columnTitlesForSupervisor : columnTitles;
  const profileOptionsToUse = isSupervisor
    ? optionsProfileForSupervisor
    : optionsProfile;
  const activeRenderer = isSupervisor
    ? cellRendererForSupervisor
    : cellRenderer;

  const registerUser = async () => {
    if (!canEditName && !canEditUsername) {
      setMessageAlertError("No tienes permisos para editar usuarios");
      setShowAlertError(true);
      return;
    }

    if (!saveItem) return;

    // Validar password únicamente si fue capturado
    if (editPassword.trim()) {
      if (!validatePassword(editPassword)) {
        setMessageAlertError("La contraseña no cumple los requisitos.");
        setShowAlertError(true);
        return;
      }

      if (editPassword !== editPasswordConfirm) {
        setMessageAlertError("Las contraseñas no coinciden.");
        setShowAlertError(true);
        return;
      }
    }

    try {
      // Actualizar datos del usuario
      const body = {
        regionIds: isAdmin ? editRegions : saveItem.regionIds,
        user: canEditUsername ? editEmail : saveItem.user,
        phone: editPhone.trim(),
        profile: {
          code: editCode.trim(),
          alias: editAlias.trim(),
          class: editProfile,
          name: canEditName ? editName : saveItem.profile.name,
          typeAgent: "_ADJUSTER_",
          tz: "America/Mexico_City",
        },
      };

      let response = null;

      if (hasUserChanges) {
        response = await updateUser(saveItem._id, body);
        if (response?.success === false) {
          setMessageAlertError(
            response?.message || "Error al actualizar usuario",
          );
          setTypeAlertError("error");
          setShowAlertError(true);
          return;
        }
      }

      if (hasPasswordChange) {
        const bodyPassword = {
          idUser: saveItem._id,
          password: editPassword,
        };
        response = await updatePasswordFetch(bodyPassword);
        if (response?.success === false) {
          setMessageAlertError(
            response?.message || "Error al actualizar contraseña",
          );
          setTypeAlertError("error");
          setShowAlertError(true);
          return;
        }
      }

      setMessageAlert(response?.message || "Usuario actualizado correctamente");
      setTypeAlert("success");
      setShowAlert(true);

      setTimeout(() => {
        setIsModalVisible(false);
        getAgentsData();
        setShowAlert(false);
      }, 1200);
    } catch (error) {
      setMessageAlertError(error?.message || "Error al actualizar usuario");
      setTypeAlertError("error");
      setShowAlertError(true);
    }
  };

  const hasPasswordChange = editPassword.trim() !== "";

  const hasUserChanges =
    saveItem &&
    (editName !== saveItem.profile?.name ||
      editEmail !== saveItem.user ||
      editPhone !== (saveItem.phone || "") ||
      editAlias !== (saveItem.profile?.alias || "") ||
      editCode !== (saveItem.profile?.code || "") ||
      editProfile !== saveItem.profile?.class ||
      JSON.stringify(editRegions) !==
        JSON.stringify((saveItem.regionIds || []).map((r) => r._id || r)));

  const deleteAgent = async () => {
    if (!canDeleteUser) {
      setMessageAlertError("No tienes permisos para eliminar usuarios");
      setShowAlertError(true);
      return;
    }
    if (!itemToDelete?._id) return;

    try {
      const response = await updateUser(itemToDelete._id, { status: 10 });

      setMessageAlert(response?.message || "Agente eliminado correctamente");
      setTypeAlert("success");
      setShowAlert(true);

      setTimeout(() => {
        setModalVisibleDelete(false);
        getAgentsData();
      }, 1500);
    } catch (error) {
      console.error(error);
      setMessageAlertError(error?.message || "Error al eliminar agente");
      setTypeAlertError("error");
      setShowAlertError(true);
    }
  };

  const ButtonsEdit = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")}
          onClick={handleCloseModal}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text24")}
          onClick={registerUser}
          backgroundColor="#1976d2"
        />
      </div>
    </>
  );

  const ButtonsDelete = () => (
    <>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label={t("Welcome.text25")} // cancelar
          onClick={handleClickTrashClose}
          backgroundColor="#9a2edb"
          color="white"
        />
      </div>
      <div style={stylesAgent.divButton}>
        <ButtonComponent
          label="Eliminar"
          onClick={deleteAgent}
          backgroundColor="#c20000"
          color="white"
        />
      </div>
    </>
  );

  return (
    <Stack style={{ ...stylesAgent.divP }}>
      <CardComponent title={t("Welcome.text105")} color="#4c4c4c">
        <Stack sx={{ alignItems: "center" }}>
          <Stack sx={{ width: "90%" }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              style={{ ...stylesAgent.divS, marginLeft: "0", width: "100%" }}
            >
              <Stack>
                <input
                  style={{
                    ...stylesAgent.input,
                    fontFamily: "Raleway, sans-serif",
                    outline: "none",
                    border: "none",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
                  }}
                  type="text"
                  autoComplete="off"
                  placeholder={t("Welcome.text122")}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Stack>
            </Stack>
            {displayedData && displayedData.length > 0 ? (
              <Stack sx={{ ...stylesAgent.stackPag }}>
                <TableLine
                  data={displayedData}
                  columnTitles={activeColumns}
                  cellComponent={activeRenderer}
                  showActionColumn={canEditUser}
                  actionColumnTitle="Acciones"
                  actionColumnLabel={
                    <EditOutlinedIcon style={{ cursor: "pointer" }} />
                  }
                  onActionClick={canEditUser ? handleEditClick : undefined}
                  showDeleteColumn={canDeleteUser}
                  showDeleteButton={canDeleteUser}
                  handleDeleteClick={
                    canDeleteUser ? handleDeleteClick : undefined
                  }
                />
              </Stack>
            ) : (
              <div>
                <table style={stylesTable.table}>
                  <thead>
                    <tr>
                      {columnTitles.map((title, index) => (
                        <th key={index} style={stylesTable.title}>
                          {title}
                        </th>
                      ))}
                      <th style={stylesTable.title}>{t("Welcome.text124")}</th>
                    </tr>
                  </thead>
                </table>
                <p style={stylesTable.column}>{t("Welcome.text61")}</p>
              </div>
            )}
            <Stack
              direction="row"
              sx={{
                width: "100%",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <Stack style={{ width: "50%", alignItems: "start" }}>
                <TablePagination
                  sx={stylesAgent.pagination}
                  component="div"
                  count={filteredData.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={t("Welcome.text89")}
                />
              </Stack>
              <Stack
                direction="row"
                sx={{
                  width: "50%",
                  alignItems: "start",
                  justifyContent: "right",
                }}
              >
                <Stack style={{ width: "30%" }}>
                  {canCreateAgent && (
                    <ButtonComponent
                      label={t("Welcome.text125")}
                      onClick={handleClickAdd}
                      backgroundColor="#73c883"
                    />
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        {/* EDITAR */}
        {isModalVisible && (
          <MuiModal
            title={t("Welcome.text126")}
            buttons={<ButtonsEdit />}
            width="700px"
            visible={isModalVisible}
            onClose={handleCloseModal}
          >
            <Stack>
              {showAlertError && (
                <AlertComponent
                  message={messageAlertError}
                  handleClose={() => setShowAlertError(false)}
                  typeAlert={typeAlertError}
                />
              )}
              {showAlert && (
                <AlertComponent
                  message={messageAlert}
                  handleClose={() => setShowAlert(false)}
                  typeAlert={typeAlert}
                />
              )}
              <Stack direction="row" spacing={2} alignItems="flex-start">
                <Stack sx={stylesAgent.sxM}>
                  <InputLabel
                    label={t("Welcome.text3")}
                    inputType="text"
                    inputwidth="90%"
                    value={editName}
                    setValue={setEditName}
                    onTextChange={setEditName}
                    disabled={!canEditName}
                  />

                  <InputLabel
                    label={t("Welcome.text120")}
                    inputType="text"
                    inputwidth="90%"
                    value={editEmail}
                    setValue={setEditEmail}
                    onTextChange={setEditEmail}
                    disabled={!canEditUsername}
                  />

                  <InputLabel
                    label="Nueva Contraseña (opcional)"
                    inputType="password"
                    inputwidth="90%"
                    value={editPassword}
                    setValue={setEditPassword}
                    onTextChange={handleEditTextChangePass}
                    showEye={true}
                  />
                  <InputLabel
                    label="Confirmar Contraseña"
                    inputType="password"
                    inputwidth="90%"
                    value={editPasswordConfirm}
                    setValue={setEditPasswordConfirm}
                    onTextChange={handleEditConfirmPass}
                    showEye={false}
                  />
                  {editPassword && <TooltipPassword />}
                  {editPresentPassConfirm && editPassword && (
                    <Alert severity="error">{editErrorMessagePass}</Alert>
                  )}
                </Stack>
                <Stack sx={stylesAgent.sxM}>
                  <InputLabel
                    label={t("Welcome.text121")}
                    inputType="select"
                    selectwidth="90%"
                    options={profileOptionsToUse}
                    value={editProfile}
                    hdlOnChange={setEditProfile}
                  />
                  <InputLabel
                    label="Teléfono"
                    inputType="text"
                    inputwidth="90%"
                    value={editPhone}
                    setValue={setEditPhone}
                  />
                  <InputLabel
                    label="Alias"
                    inputType="text"
                    inputwidth="90%"
                    value={editAlias}
                    setValue={setEditAlias}
                  />
                  <InputLabel
                    label="Código"
                    inputType="text"
                    inputwidth="90%"
                    value={editCode}
                    setValue={setEditCode}
                  />

                  {isAdmin ? (
                    editRegions.map((regId, index) => (
                      <Stack
                        key={index}
                        direction="row"
                        alignItems="center"
                        spacing={1}
                      >
                        <Stack sx={{ width: "90%" }}>
                          <InputLabel
                            label={index === 0 ? t("Welcome.text301") : ""}
                            inputType="select"
                            selectwidth="100%"
                            options={regionOptions}
                            value={regId}
                            hdlOnChange={(val) =>
                              handleEditRegionChange(index, val)
                            }
                          />
                        </Stack>
                        <Stack
                          direction="row"
                          sx={{ marginTop: index === 0 ? "20px" : "0px" }}
                        >
                          {editRegions.length > 1 && (
                            <Tooltip title="Eliminar región">
                              <RemoveCircleOutline
                                sx={{
                                  cursor: "pointer",
                                  color: "#c20000",
                                  fontSize: 20,
                                }}
                                onClick={() => handleRemoveEditRegion(index)}
                              />
                            </Tooltip>
                          )}
                          {index === editRegions.length - 1 && (
                            <Tooltip title="Agregar región">
                              <AddCircleOutline
                                sx={{
                                  cursor: "pointer",
                                  color: "#73c883",
                                  fontSize: 20,
                                }}
                                onClick={handleAddEditRegion}
                              />
                            </Tooltip>
                          )}
                        </Stack>
                      </Stack>
                    ))
                  ) : (
                    <></>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </MuiModal>
        )}
        {/* AGREGAR */}
        {modalVisibleAdd && (
          <MuiModal
            title={t("Welcome.text125")}
            buttons={<Buttons />}
            width="700px"
            visible={modalVisibleAdd}
            onClose={handleCloseModalAdd}
          >
            {showAlertError && (
              <AlertComponent
                message={messageAlertError}
                handleClose={() => setShowAlertError(false)}
                typeAlert={"error"}
              />
            )}
            {showAlert && (
              <AlertComponent
                message={messageAlert}
                handleClose={() => setShowAlert(false)}
                typeAlert={typeAlert}
              />
            )}
            <Stack
              direction="row"
              spacing={2}
              alignItems="flex-start"
              sx={{ textAlign: "left" }}
            >
              <Stack sx={{ width: "50%", marginLeft: "1rem" }}>
                <InputLabel
                  label={t("Welcome.text3")}
                  inputType="text"
                  inputwidth="90%"
                  value={name}
                  setValue={(v) => {
                    setName(v);
                    handleTextChangeName(v);
                  }}
                />

                <InputLabel
                  label={t("Welcome.text120")}
                  inputType="text"
                  inputwidth="90%"
                  value={email}
                  setValue={(v) => {
                    setEmail(v);
                    handleTextChangeUser(v);
                  }}
                />

                <InputLabel
                  label={t("Welcome.text121")}
                  inputType="select"
                  selectwidth="95%"
                  options={profileOptionsToUse}
                  hdlOnChange={setUserType}
                  value={userType}
                />
                        <InputLabel
                  label="Teléfono"
                  inputType="text"
                  inputwidth="90%"
                  value={phone}
                  setValue={setPhone}
                />
                <InputLabel
                  label="Alias"
                  inputType="text"
                  inputwidth="90%"
                  value={alias}
                  setValue={setAlias}
                />
                <InputLabel
                  label="Código"
                  inputType="text"
                  inputwidth="90%"
                  value={code}
                  setValue={setCode}
                />
                {selectedRegions.map((regId, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Stack sx={{ width: "90%" }}>
                      <InputLabel
                        label={index === 0 ? t("Welcome.text301") : ""}
                        inputType="select"
                        selectwidth="100%"
                        options={regionOptions}
                        value={regId}
                        hdlOnChange={(val) => handleRegionChange(index, val)}
                      />
                    </Stack>
                    <Stack
                      direction="row"
                      sx={{ marginTop: index === 0 ? "20px" : "0px" }}
                    >
                      {selectedRegions.length > 1 && (
                        <Tooltip title="Eliminar región">
                          <RemoveCircleOutline
                            sx={{
                              cursor: "pointer",
                              color: "#c20000",
                              fontSize: 20,
                            }}
                            onClick={() => handleRemoveRegion(index)}
                          />
                        </Tooltip>
                      )}
                      {index === selectedRegions.length - 1 && (
                        <Tooltip title="Agregar región">
                          <AddCircleOutline
                            sx={{
                              cursor: "pointer",
                              color: "#73c883",
                              fontSize: 20,
                            }}
                            onClick={handleAddRegion}
                          />
                        </Tooltip>
                      )}
                    </Stack>
                  </Stack>
                ))}
              </Stack>
              <Stack sx={{ width: "50%", marginLeft: "1rem" }}>
                <Stack>
                  <InputLabel
                    label={t("Welcome.text128")}
                    inputType="password"
                    inputwidth="85%"
                    value={password}
                    setValue={setPassword}
                    onTextChange={handleTextChangePass}
                  />
                  <InputLabel
                    label={t("Welcome.text248")}
                    inputType="password"
                    inputwidth="85%"
                    value={passwordConfirm}
                    setValue={setPasswordConfirm}
                    onTextChange={handleConfirmPass}
                  />
                  <TooltipPassword />
                  {presentPassConfirm && (
                    <Alert severity="error">{errorMessagePass}</Alert>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </MuiModal>
        )}
        {/* ELIMINAR */}
        {modalVisibleDelete && (
          <MuiModal
            title={t("Welcome.text129")}
            buttons={<ButtonsDelete />}
            width="700px"
            visible={modalVisibleDelete}
            onClose={handleClickTrashClose}
          >
            {showAlert && (
              <AlertComponent
                message={messageAlert}
                handleClose={() => setShowAlert(false)}
                typeAlert={typeAlert}
              />
            )}
            {showAlertError && (
              <AlertComponent
                message={messageAlertError}
                handleClose={() => setShowAlertError(false)}
                typeAlert={typeAlertError}
              />
            )}
            <Typography variant="body1" sx={{ textAlign: "left" }}>
              {t("Welcome.text130")} <strong>{saveName}</strong>?
            </Typography>
          </MuiModal>
        )}
      </CardComponent>
    </Stack>
  );
}

export default Agentes;
